<!--<ng-container *ngIf="useWC; then webComponents; else legacyComponents"></ng-container>-->
<!--<ng-template #webComponents>-->
<!--  <lm-text-wc-->
<!--    [layoutObject]="layoutObject"-->
<!--    [specFields]="specFields"-->
<!--    [model]="model"-->
<!--    [mutexSpecField]="mutexSpecField"-->
<!--    [placeHolder]="placeHolder"-->
<!--    [layoutInfo]="layoutInfo"-->
<!--    [lmColumnLayoutInfo]="lmColumnLayoutInfo"-->
<!--    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"-->
<!--    [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"-->
<!--    (fieldEvent)="onFieldEvent($event)"-->
<!--    (errorOnMemberField)="onErrorMemberField($event)"-->
<!--  ></lm-text-wc>-->
<!--</ng-template>-->
<!--<ng-template #legacyComponents>-->
  <lm-text-soho
    class="field"
    [layoutObject]="layoutObject"
    [specFields]="specFields"
    [model]="model"
    [mutexSpecField]="mutexSpecField"
    [placeHolder]="placeHolder"
    [layoutInfo]="layoutInfo"
    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
    [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
    (fieldEvent)="onFieldEvent($event)"
    (errorOnMemberField)="onErrorMemberField($event)"
  ></lm-text-soho>
<!--</ng-template>-->
